import React from "react";
import { IT } from "../../../consts";
import GoogleStrategy from "./GoogleStrategy";
import OutlookStrategy from "./OutlookStrategy";

const IntegrationContext = React.createContext("");

/**
 *
 * @param integrationType
 * @param widget
 * @returns {CalendarIntegrationStrategy}
 */
export const getStrategy = (integrationType, widget) => {
  switch (integrationType) {
    case IT.google:
      return new GoogleStrategy(widget);
    case IT.outlook:
      return new OutlookStrategy(widget);
  }
};

export default IntegrationContext;
